import React from "react";
import {
  HomeOutline,
  EllipsisHorizontalCircle,
  BriefcaseOutline,
  Star,
  Trash,
  TrashOutline,
  PencilOutline,
} from "react-ionicons";

const FAddressCard = ({
  address,
  className,
  onClick,
  enableButtonDelete = false,
  onDeleteAddress,
  onEditAddress
}) => {
  return (
    <div className="border-0 rounded-xl shadow-Box my-2 p-3 grid grid-cols-12">
      <div
        onClick={() => {
          onClick(address);
        }}
        className={`border-0 w-full col-span-11 grid grid-cols-1 smm:grid-cols-2 my-2 ${!className ? "" : className
          }`}
      >
        <div className="border-0 col-span-1 sm:col-span-2 grid grid-cols-2">
          <div className="border-0 col-span-2 pb-2">
            <div className="float-left font-bold">
              {address.address.typeOfAddressId == "HOME" ? (
                <HomeOutline height="21px" width="21px" />
              ) : null}
              {address.address.typeOfAddressId == "WORK" ? (
                <BriefcaseOutline height="21px" width="21px" />
              ) : null}
              {address.address.typeOfAddressId == "OTHER" ? (
                <EllipsisHorizontalCircle height="21px" width="21px" />
              ) : null}
            </div>
            <div className="float-left font-bold">
              &nbsp;
              {address.address.typeOfAddressId == "HOME" ? "CASA" : null}
              {address.address.typeOfAddressId == "WORK" ? "TRABAJO" : null}
              {address.address.typeOfAddressId == "OTHER" ? "OTRO" : null}
            </div>
            <div className="border-0 col-span-1 pl-2 grid items-end font-regular text-[4vw] xxxs:text-[13px]">
                {address.address.tag}
              </div>
          </div>
        </div>
        <div className="border-0 col-span-2">
          <p className="float-left font-regular break-words">
            {/* <p className="float-left font-bold">{"Dirección:"}&nbsp;&nbsp;</p> */}
            {address.address.label}
          </p>
        </div>
        
      </div>
      <div className="border-0 col-span-1 my-2">
        <div className="border-0 w-full grid place-items-center">
          {address.address.isPrincipal ? (
            <Star height="21px" width="21px" color={"#2196f3"} />
          ) : enableButtonDelete ? (
            <Trash
              color={"#E30000"}
              onClick={() => {
                onDeleteAddress(address);
              }}
            />
          ) : null}
          {!onEditAddress ? null : (          <PencilOutline
           height="21px" width="21px"
           cssClasses={"mt-2 cursor-pointer"}
            onClick={onEditAddress}
          />)}

        </div>
      </div>
    </div>
  );
};

export default FAddressCard;
